import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./trustpilot-scoreless.module.css";
import TrustpilotLogo from "./assets/trustpilot-logo.svg";
import { formatNumber } from "@cinch-labs/shared-util";
import { Text } from "@cinch-labs/design-system";
import cx from "classnames";
/**
 * TrustpilotScoreless component
 * @component
 * @param {object} props
 * @param {boolean} props.shouldShowFirstLine - Whether to show the first line of text or not
 * @param {number?} props.numberOfReviews - The number of reviews. You can get this using the `useTrustpilotReviewCount` hook if you do not have it already
 *
 * @example <TrustpilotScoreless numberOfReviews={trustpilotReviewCount} />
 * @example <TrustpilotScoreless numberOfReviews={trustpilotReviewCount} shouldShowFirstLine={true} />
 *
 * @returns {JSX.Element}
 */ export const TrustpilotScoreless = ({ shouldShowFirstLine =true , numberOfReviews  })=>{
    const formattedReviews = numberOfReviews !== undefined ? formatNumber(numberOfReviews) : "";
    const secondLineContent = formattedReviews ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            "See our ",
            /*#__PURE__*/ _jsx("span", {
                className: styles.boldText,
                children: formattedReviews
            }),
            " ",
            "reviews on"
        ]
    }) : "See our reviews on";
    return /*#__PURE__*/ _jsxs("a", {
        className: styles.container,
        "data-testid": "trust-pilot-scoreless",
        href: "/customer-reviews",
        target: "_blank",
        children: [
            shouldShowFirstLine && /*#__PURE__*/ _jsx("div", {
                className: styles.firstLine,
                children: /*#__PURE__*/ _jsx(Text, {
                    element: "p",
                    fontWeight: "book",
                    fontSizeFixed: "s",
                    lineHeight: "display",
                    children: "Don't just take our word for it."
                })
            }),
            /*#__PURE__*/ _jsxs(Text, {
                element: "p",
                fontWeight: "book",
                fontSizeFixed: "s",
                lineHeight: "display",
                className: cx(styles.secondLine, !shouldShowFirstLine && styles.singleLine),
                children: [
                    secondLineContent,
                    /*#__PURE__*/ _jsx(TrustpilotLogo, {
                        className: styles.logo,
                        "aria-label": "Trustpilot"
                    })
                ]
            })
        ]
    });
};
